export default __webpack_public_path__ + "static/media/basic.f67895af.png";